import ContentLoader from 'react-content-loader'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'

interface IProps {
  isMobile: any
}

const LoaderQuestion = (props: IProps) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <>
      {!props.isMobile ? (
        <div style={{ marginLeft: '5%' }}>
          <div style={{ display: 'flex', width: '80%', marginTop: '24px' }}>
            <div style={{ display: 'flex', gap: '3px', width: '100%' }}>
              <ContentLoader width={'100%'} height={100} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="100%" height="70" />
              </ContentLoader>
            </div>
          </div>
          <div style={{ display: 'flex', width: '100%', height: '20%' }}>
            <div style={{ flexDirection: 'column', gap: '3px', width: '100%' }}>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="10%" height="20" />
                <rect x="300" y="0" rx="6" ry="6" width="45%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="30%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="20%" height="20" />
              </ContentLoader>
            </div>
          </div>
          <div style={{ display: 'flex', width: '100%', height: '20%' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
                width: '100%',
              }}
            >
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="80%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="80%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="80%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="80%" height="20" />
              </ContentLoader>
            </div>
          </div>
          <div style={{ width: '100%', height: '20%' }}>
            <div style={{ flexDirection: 'column', gap: '3px', width: '100%' }}>
              <ContentLoader width={'90%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
              <ContentLoader width={'90%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
              <ContentLoader width={'90%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
              <ContentLoader width={'90%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div style={{ display: 'flex', width: '100%', marginTop: '24px' }}>
            <div style={{ display: 'flex', gap: '3px', width: '100%' }}>
              <ContentLoader width={'100%'} height={100} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="90%" height="70" />
              </ContentLoader>
            </div>
          </div>
          <div style={{ display: 'flex', width: '100%', height: '20%' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
                width: '100%',
              }}
            >
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="10%" height="20" />
                <rect x="120" y="0" rx="6" ry="6" width="45%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="30%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="20%" height="20" />
              </ContentLoader>
            </div>
          </div>
          <div style={{ display: 'flex', width: '100%', height: '20%' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
                width: '100%',
              }}
            >
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="90%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="90%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="90%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <rect x="0" y="0" rx="6" ry="6" width="90%" height="20" />
              </ContentLoader>
            </div>
          </div>
          <div style={{ width: '100%', height: '20%' }}>
            <div style={{ flexDirection: 'column' }}>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
              <ContentLoader width={'100%'} height={50} {...LoaderProps}>
                <circle cx="25" cy="25" r="20" />
                <rect x="100" y="15" rx="6" ry="6" width="70%" height="20" />
              </ContentLoader>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default LoaderQuestion
